export const UTCtoLocalDateTime = (utcDateTime) => {
    try {
        let date;

        if (utcDateTime.includes('T') && utcDateTime.includes('+0000')) {
            const utcString = utcDateTime.replace('+0000', 'Z');
            date = new Date(utcString);
        } else if (utcDateTime.includes(' ') && !utcDateTime.includes('T')) {
            const utcString = utcDateTime.replace(' ', 'T') + 'Z';
            date = new Date(utcString);
        } else if (utcDateTime.includes('T') && !utcDateTime.includes('Z') && !utcDateTime.includes('+')) {
            const utcString = utcDateTime + 'Z';
            date = new Date(utcString);
        } else {
            date = new Date(utcDateTime);
        }

        if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
        }

        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear().toString().slice(-2);
        const formattedDate = `${day} ${month} '${year}`;

        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHours = hours % 12 || 12;
        const formattedTime = `${displayHours}:${minutes}:${seconds} ${ampm}`;

        return {
            date: formattedDate,
            time: formattedTime
        };
    } catch (error) {
        console.error('Error converting UTC time:', error);
        return {
            date: 'Invalid Date',
            time: 'Invalid Time'
        };
    }
};

export const formatUTCTime = (utcDateTime, returnType = 'both') => {
    const converted = UTCtoLocalDateTime(utcDateTime);

    switch (returnType) {
        case 'date':
            return converted.date;
        case 'time':
            return converted.time;
        case 'both':
            return `${converted.date}, ${converted.time}`;
        default:
            return `${converted.date} at ${converted.time}`;
    }
};